export const FIELDS = [
  {
    name: 'info.accountNo',
    label: 'Greenbelt Account Number',
    type: 'number',
  },
  {
    name: 'info.serialNumber',
    label: 'Serial Number',
    type: 'number',
  },
];
